import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Houston needed",
      "Ideal for McConnell AFB military families",
      "Perfect for aerospace business travelers",
      "Great for WSU students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Wichita post offices",
      "Good for planned international trips from ICT",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Sedgwick County facilities",
      "Workload shifts with government shutdowns",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Houston — ~600 miles via I-35/I-45 — no Wichita walk-in",
      "NPIC appointment required before traveling",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function WichitaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Wichita"
      introText="Wichita travelers — McConnell AFB families, aerospace executives at Spirit AeroSystems and Textron, Wichita State University students, and Koch Industries professionals — have several options for getting a passport fast. Here is how they compare, and why most South Central Kansas residents choose a registered passport courier for predictable, professional processing without the drive to Houston."
      options={options}
      emergencyDescription="Wichita does not have its own regional passport agency. The closest is Houston — approximately 600 miles, 8.5 hours via I-35 and I-45. McConnell AFB families with deployment orders face 17+ hours round-trip. I-35 construction through Oklahoma and Texas adds unpredictable delays during summer travel season."
      disclaimerText="*Processing speed depends on eligibility and documentation. Wichita does not have a regional passport agency — the closest is Houston, roughly 600 miles and 8.5 hours away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}